import { render, staticRenderFns } from "./OptionHistory.vue?vue&type=template&id=3f287a66&"
import script from "./OptionHistory.vue?vue&type=script&lang=js&"
export * from "./OptionHistory.vue?vue&type=script&lang=js&"
import style0 from "./OptionHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports